import { createFileRoute } from '@tanstack/react-router'

import { TiersPage } from '@/pages/admin/tiers/tiers-page'

export const Route = createFileRoute('/_private/admin/tiers')({
  component: TiersPage,
})
